<template>
	<div class="nav-bar" :style="{background:this.$root.colorController}">
		<img class="logo" :src="logoPath" alt="">

		<el-dropdown class="dropdown" :style="{color:(this.$root.colorController == '#000' ? '#bdbdbd' : '#000')}">
			<a>
				<i class="user el-icon-user-solid"></i>
				{{name}}
				<i class="arrow el-icon-arrow-down"></i>
			</a>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item icon="el-icon-edit-outline" @click.native="formVisable = true">修改密码</el-dropdown-item>
				<el-dropdown-item icon="el-icon-unlock" @click.native="logout()">注销</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>


		<el-dropdown class="dropdown-color"
			:style="{color:(this.$root.colorController == '#000' ? '#bdbdbd' : '#000')}">
			<a>
				<span v-if="colConFalg === false">
					<img style="height:20px; width: 20px; margin-right: 5px; margin-top: -5px;"
						src="../../../assets/img/color/clothes.png" alt="白" />
				</span>

				<span v-else>
					<img style="height:20px; width: 20px; margin-right: 5px;margin-top: -5px;"
						src="../../../assets/img/color/clothes-black.png" alt="黑" />
				</span>


				<i class="arrow el-icon-arrow-down" style="margin-top: 6px;"></i>
			</a>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item @click.native="changeColor('#cecece')">
					<img style="height:25px; width: 25px;" src="../../../assets/img/color/grey.png" alt="灰色" />
				</el-dropdown-item>
				<el-dropdown-item @click.native="changeColor('#000')">
					<img style="height:25px; width: 25px;" src="../../../assets/img/color/black.png" alt="黑色" />
				</el-dropdown-item>
				<el-dropdown-item @click.native="changeColor('#e0620d')">
					<img style="height:25px; width: 25px;" src="../../../assets/img/color/orange.png" alt="红色" />
				</el-dropdown-item>
				<el-dropdown-item @click.native="changeColor('#00ff00')">
					<img style="height:25px; width: 25px;" src="../../../assets/img/color/green.png" alt="绿色" />
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>

		<!-- 车辆报警信息指示-->
		<div class="bell-style" @mouseenter="enter" @mouseleave="leave"  v-loading="warnLstLoading">
			<span v-if="colConFalg === false">
				<img style="height:23px; width: 23px; margin-top: 8px;" src="../../../assets/img/color/bell.png"
					alt="铃铛" /> <!-- @click="clickBill()" -->
				<span style="color:#ff9932;font-size: 14px;">{{warningCount}}</span>
			</span>

			<span v-else>
				<img style="height:23px; width: 23px; margin-top: 8px;" src="../../../assets/img/color/bell-black.png"
					alt="铃铛" /> <!-- @click="clickBill()" -->
				<span style="color:#ff9932;font-size: 14px;">{{warningCount}}</span>
			</span>
		</div>
		<!-- 车辆报警信息框 -->
		<div  v-show="bellWarnShow && warningCount>0" class="bell-warn-style" @mouseover="mouseover" @mouseleave="leave">
			<el-scrollbar style="height: 100%;width: 100%;margin-left:10px;" class="scrollbar-for-y">
				<div class="choose-bank">
					<ul style="overflow: auto;">
						<li v-for="(item, index) in lstWarnInfo" :key="index"
							style="border-bottom: 1px solid #008800;display:flex;justify-content: space-between;margin-right: 15px;">
							<div>
								<span style="line-height: 50px; padding: 5px;">{{item.carName}}</span>
								<span style="font-size: 0.8rem;">({{item.carId}})</span>
							</div>
<!-- 							<div style="width: 100px;line-height: 50px; padding: 5px;"  v-if="item.statusBoxRubbish == 1">
								垃圾箱溢出
							</div>
							<div style="width: 100px;line-height: 50px; padding: 5px;"  v-if="item.statusBoxWater == 1">
								水箱不足
							</div>
							<div style="display: flex;width:200px;" v-if="item.statusOther != null">								
								<div style="float: left;line-height: 50px; padding: 2px;" v-if="item.statusOther.includes('1')">
									人机切换
								</div>
								<div style="float: left;line-height: 50px; padding: 2px;" v-if="item.statusOther.includes('2')">
									连接断开
								</div>
								<div style="float: left;line-height: 50px; padding: 2px;" v-if="item.statusOther.includes('3')">
									耗材更换
								</div>
							</div> -->
							<div  style="float: left;line-height: 50px; padding: 2px;"  >
								{{item.info}}
							</div>
							<el-button-group style="width: 130px;text-align: right;margin-top:10px;">
								<!-- <el-button type="success" size="mini" @click="handleWarning(item)">
									已读
								</el-button> -->
								<el-button type="primary" size="mini" @click="clickBill(item)">
									详情
								</el-button>
							</el-button-group>
						</li>
					</ul>
				</div>
			</el-scrollbar>

			<!-- <el-table :data="lstWarnInfo"
		border
		highlight-current-row>
			<el-table-column prop="carid" label="车辆id" width="160px" align="center">
			</el-table-column>
			<el-table-column prop="boxRubbish" label="垃圾箱预警" width="100px" align="center">
			</el-table-column>
			<el-table-column prop="boxWater" label="水箱预警" width="100px" align="center">
			</el-table-column>
			<el-table-column prop="boxOther" label="其他预警" width="100px" align="center">
			</el-table-column>
			<el-table-column prop="operator" label="操作" align="center">
			  <template v-slot:="">
			    <el-button-group>
			      <el-button type="primary" size="mini" @click="">
			        已读
			      </el-button>
			      <el-button type="primary" size="mini" style="margin-left:10px" @click="">
			        详情
			      </el-button>
			    </el-button-group>
			  </template>
			</el-table-column>
		</el-table> -->
		</div>


		<!-- 弹出编辑框 -->
		<el-dialog title="修改密码" :visible.sync="formVisable">
			<el-form :model="form">
				<el-form-item label="请输入新密码" label-width="120px">
					<el-col :span="12">
						<el-input v-model="form.newPassword" show-password placeholder="请输入新密码"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="请再次输入密码" label-width="120px">
					<el-col :span="12">
						<el-input v-model="form.rePassword" show-password placeholder="请再次输入密码"></el-input>
					</el-col>
				</el-form-item>
			</el-form>

			<div slot="footer" class="footer">
				<el-button @click="formVisable = false">取消</el-button>
				<el-button type="primary" @click="formSub()">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import vueCustomScrollbar from 'vue-custom-scrollbar'
	import "vue-custom-scrollbar/dist/vueScrollbar.css"
	import * as types from '@/store/mutation-types'
	import {
		doLogout
	} from '@/api/login'

	import {
		getUnHandle,
		handleWarning
	} from '@/api/warning'

	export default {
		name: 'NavBar',
		components: {
			vueCustomScrollbar
		},
		data() {
			return {
				name: this.$store.getters['user/userName'],
				formVisable: false,
				form: {
					newPassword: '',
					rePassword: ''
				},
				colConFalg: false,
				rules: {

				},
				warningCount: 0, //车辆预警个数

				response: undefined,

				warnLstLoading:true,
				bellWarnShow: false, //车辆预警展示信息框
				lstWarnInfo: [], //车辆预警信息

			}
		},
		methods: {
			logout() {
				this.$store.dispatch('user/logout').then(res => {
					// 注销成功
					this.$router.push('/login')
				})

				this.$root.closeTages = false;
			},

			enter() {
				// $('.bell-warn-style').css('display','block');	
				this.bellWarnShow = true;
			},
			leave() {
				// $('.bell-warn-style').css('display','none');	
				this.bellWarnShow = false;
			},
			mouseover() {
				// $('.bell-warn-style').css('display','block');
				this.bellWarnShow = true;
			},

			/**
			 * 点击铃铛事件
			 * 车辆预警
			 */
			clickBill(item) {
				// localStorage.setItem("warningCarId", this.response.data[0].carId)
				localStorage.setItem("warningCarId", item.carId)
				if (this.$router.history.current.fullPath != "/monitor/carMonitor") { //跳转到车辆实时监控-日志报警tab
					this.$router.push({
						name: 'car_monitor',
					});
				} else {
					// location.reload()
				}
			},
			/**
			 * @param {Object} row
			 * 预警已读
			 */
			handleWarning(row) {
				let that = this
				that.warnLstLoading = true
			    handleWarning(row.id).then(res => {
					if (res.result != "200") {
					  that.$message.error(res.message)
					} else {
					  that.$message.success(res.message)
					  that.$store.dispatch('warning/updateHandled', true);
					  that.bellWarnShow = false
					  that.checkUnHandle()
					  // location.reload() //刷新页面
					}
			    })
			},

			/**
			 * @param {Object} val
			 * 切换颜色
			 */
			changeColor(val) {
				this.$root.colorController = val
				if (val == '#000') {
					this.colConFalg = false;
				} else {
					this.colConFalg = true;
				}
			},

			/**
			 * 查询登录用户所在运营点下车辆报警信息
			 */
			checkUnHandle() {
				let that = this
				getUnHandle(this.$store.getters['user/entityId']).then(res => {
					that.warningCount = res.count;
					that.lstWarnInfo = res.data
					// this.response = res;
					that.warnLstLoading = false
					// console.log(that.lstWarnInfo);
				})
			},
			formSub() {
				this.inputValidate()
				this.formVisable = false
			}
		},
		props: {
			logoPath: {
				type: String
			}
		},

		mounted() {
			/**
			 * 获取未处理车辆预警
			 */
			this.checkUnHandle()
		}
	}
</script>

<style scoped>
	.nav-bar {
		position: relative;
		padding: 0 20px;
		background: #000;
	}

	.logo {
		position: absolute;
		bottom: 5px;
		height: 30px;
	}

	.dropdown {
		float: right;
		width: 115px;
		height: 100%;
		/* color: #fff; */
		/* background: rgba(255,255,255,.1); */
	}

	.dropdown-color {
		float: right;
		width: 45px;
		top: 8px;
		height: 100%;
		/* color: #ffffff; */
	}

	.dropdown .down-button {
		width: 100%;
		height: 100%;
	}

	.dropdown i {
		text-align: center;
		line-height: 30px;
	}

	.dropdown .user {
		width: 30px;
		height: 30px;
		margin: 5px 0 5px 5px;
		background: rgba(255, 255, 255, .1);
		font-size: 20px;
	}

	.dropdown .arrow {
		width: 20px;
		height: 10px;
		font-size: 14px;
	}

	.el-dropdown-menu_item {
		padding: 6px 0 6px 13px;
	}

	.bell-style {
		float: right;
		width: 45px;
		top: 8px;
		height: 100%;
	}

	.bell-warn-style {
		width: 800px;
		height: 200px;
		right: 10px;
		top: 35px;
		z-index: 1000;
		/* display: none; */
		position: absolute;
		border: 1px solid #00aa00;
		background: rgba(255, 255, 255, .8);
	}
</style>
